import styled from 'styled-components'

export const AddBasicCompanyDataFormChooseFileFieldsContainer = styled.div``
